import { render, staticRenderFns } from "./PanelDeControlView.vue?vue&type=template&id=425664dc&"
import script from "./PanelDeControlView.vue?vue&type=script&lang=js&"
export * from "./PanelDeControlView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports